import { Grid, GridItem, Spacer, Text, Tooltip } from "@chakra-ui/react";
import EasterEgg from "../Components/EasterEgg";

export default function About(){
    return(
        
            <Grid templateColumns="1fr 1fr" gap={50}>
                <GridItem style={{textAlign:"left"}}>
                <header style={{textDecoration:"underline", textAlign:"center"}}>About</header>
                    <Text>This project was made October 14-21, 2023 for <a href="https://itch.io/jam/qgjam-2023">The Queerness and Games Jam</a>,
            by a proudly partnered, out LGBT+ adult. My hope was to share the idea and the fact that it is ok to find a way to
            know who you are, to know yourself and what you want. It's OK to say your name out loud, to make mistakes, to ask questions.
            Even if you find no answer, it's okay.
            It's OK to be who you are, and I believe in your ability to - at some time, in some way - to make something, find something,
             say something, share something, learn something. </Text>
                <br/>
                <Text>I think there are ways to question yourself (and the barriers and expecations you find) that can bring some peace,
                    places to shelter, ways across the flood. 
                </Text>
                <br/>
                <Text>For a long time I felt scared of myself and my "queerness", and I hope you feel some joy and hope from a place I've found on the other side of fear.</Text>
                </GridItem>

                <GridItem style={{textAlign:"center"}}>
                    <header style={{textDecoration:"underline"}}>Original concept</header>
                    <Text>3-20 minute experiential guided therapy App, emphasizing open-ended and solution-focused questions.
Primarily text based, may include art based exercises.
Player choices include name and other details being provided as the App learns about the user, ability to create or approve of UI theme elements.
Music sets a soothing but engaged tone, and may progressively change as the player works through prompts (adaptive music).
Design focuses on creating a positive and safe environment, smooth and predictable transitions, and finding meaningful connection with diverse users in ways that respect and empower them, while inviting them to find new ways of questioning and moving through their own journey.</Text>
                    <br/>
                    <Spacer h="20px"/>
                    <Tooltip label='Audio Easter Egg'>
                        <EasterEgg/>
                    </Tooltip>
                </GridItem>
            </Grid>        
        )
    }